import SectionComponent from "@inter-ikea-storagetwo/range/dist/components/SectionComponent";
import InsertComponent from "@inter-ikea-storagetwo/range/dist/components/InsertComponent";
import StabilityZonesComponent from "@inter-ikea-storagetwo/range/dist/components/StabilityZonesComponent";
import HeightRestrictedComponent from "@inter-ikea-storagetwo/range/dist/components/HeightRestrictedComponent";
import NonWorldlyItemComponent from "@inter-ikea-storagetwo/range/dist/components/NonWorldlyItemComponent";
import BlockConnectionHoleComponent from "@inter-ikea-storagetwo/range/dist/components/BlockConnectionHoleComponent";
export const components = {
    SectionComponent,
    InsertComponent,
    NonWorldlyItemComponent,
    StabilityZonesComponent,
    HeightRestrictedComponent,
    BlockConnectionHoleComponent,
};
